import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, MenuItem
} from '@mui/material';
import axiosInstance from '../utils/axiosInstance';

const PurchaseWarehouseChangeModal = ({
    open,
    onClose,
    purchaseId,
    currentWarehouse,
    warehouses,
    showSnackbar,
    onSuccess
}) => {
    const [selectedWarehouse, setSelectedWarehouse] = useState(currentWarehouse || null);

    useEffect(() => {
        setSelectedWarehouse(currentWarehouse || null);
    }, [currentWarehouse]);

    const handleConfirm = async () => {
        if (!selectedWarehouse) {
            showSnackbar('倉庫を選択してください', 'warning');
            return;
        }

        try {
            await axiosInstance.put(`/purchase/${purchaseId}/update-warehouse`, {
                warehouse_id: selectedWarehouse.warehouse_id,
            });

            showSnackbar(`${selectedWarehouse.warehouse_name}に倉庫を変更しました`, 'success');
            onClose();
            onSuccess?.(); // 親に更新を通知
        } catch (err) {
            console.error(err);
            showSnackbar(err?.response?.data?.message || '倉庫変更に失敗しました', 'error');
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>倉庫を変更</DialogTitle>
            <DialogContent>
                <TextField
                    select
                    label="倉庫"
                    value={selectedWarehouse?.warehouse_id || ''}
                    onChange={(e) => {
                        const wh = warehouses.find(w => w.warehouse_id === e.target.value);
                        setSelectedWarehouse(wh);
                    }}
                    sx={{ mt: 2 }}
                >
                    {warehouses.map((wh) => (
                        <MenuItem key={wh.warehouse_id} value={wh.warehouse_id}>
                            {wh.warehouse_name}
                        </MenuItem>
                    ))}
                </TextField>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>キャンセル</Button>
                <Button variant="contained" color="primary" onClick={handleConfirm}>
                    確定
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PurchaseWarehouseChangeModal;